"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'One Row',
  description: "Choose between a vertical to horizontal scrolled gallery. Note that this option will affect\n  the availability of many other options",
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;